import { RefObject, useEffect } from 'react';
import usePage from '../../hooks/use-page';

const useZoomAutoScroll = (
  currentPage: string | number,
  scrollableContainerRef: RefObject<HTMLDivElement>,
  overflowingChildRef: RefObject<HTMLElement>
) => {
  const [{ zoomed, noOfPages }] = usePage();

  useEffect(() => {
    if (!scrollableContainerRef?.current || !overflowingChildRef?.current) {
      return;
    }
    if (!zoomed) {
      scrollableContainerRef.current.scrollTo(0, 0);
      overflowingChildRef.current.style.paddingTop = '0px';
      return;
    }

    const middleScrollPosition =
      Math.abs(
        overflowingChildRef.current.getBoundingClientRect().height -
          scrollableContainerRef.current.clientHeight
      ) / 2;

    overflowingChildRef.current.style.paddingTop = `${
      middleScrollPosition + scrollableContainerRef.current.clientHeight / 2
    }px`;

    scrollableContainerRef.current.scrollTo(0, middleScrollPosition);
  }, [currentPage, zoomed, noOfPages, scrollableContainerRef, overflowingChildRef]);
};

export default useZoomAutoScroll;
